import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { mdiClose } from '@mdi/js'

import { jobInfoNotesMessages } from '../messages'
import { commonMessages } from 'app/i18n/messages'
import { SpinnerCentered } from 'components/Loader'
import {
  JobEditCloseButton,
  JobEditNoteBody,
  JobEditNoteContainer,
  JobEditNoteErrorWrapper,
  JobEditNoteFooter,
  JobEditNoteHeader,
  JobEditNoteHeaderTitle,
  JobEditNoteIcon,
  JobEditNoteSaveButton,
  JobEditTextarea,
} from './styles'

interface JobEditNoteProps {
  text?: string
  handleClose: () => void
  handleSubmit: (text: string) => void
  isNewNote?: boolean
  isLoading?: boolean
  isError?: boolean
}

function JobEditNote({
  text = '',
  handleSubmit,
  handleClose,
  isNewNote = false,
  isLoading = false,
  isError = false,
}: JobEditNoteProps) {
  const { formatMessage } = useIntl()
  const initialText = isNewNote ? '' : text
  const [newText, setNewText] = useState(initialText)

  return (
    <JobEditNoteContainer>
      <JobEditNoteHeader>
        <JobEditNoteHeaderTitle>
          {isNewNote ? (
            <FormattedMessage {...jobInfoNotesMessages.addNoteLabel} />
          ) : (
            <FormattedMessage {...jobInfoNotesMessages.editNoteLabel} />
          )}
        </JobEditNoteHeaderTitle>
        <JobEditCloseButton onClick={() => handleClose()}>
          <JobEditNoteIcon path={mdiClose} />
        </JobEditCloseButton>
      </JobEditNoteHeader>

      <JobEditNoteBody>
        <JobEditTextarea
          placeholder={formatMessage(
            jobInfoNotesMessages.editNoteInputPlaceholder
          )}
          value={newText}
          onChange={(e) => setNewText(e.target.value)}
          maxLength={10000}
          disabled={isLoading}
        />
        {isError && (
          <JobEditNoteErrorWrapper>
            <FormattedMessage {...commonMessages.commonError} />
          </JobEditNoteErrorWrapper>
        )}
      </JobEditNoteBody>

      <JobEditNoteFooter>
        {isLoading ? (
          <SpinnerCentered size="24" />
        ) : (
          <JobEditNoteSaveButton
            variant="primary"
            onClick={() => handleSubmit(newText)}
            disabled={!newText.length}
          >
            <FormattedMessage {...commonMessages.save} />
          </JobEditNoteSaveButton>
        )}
      </JobEditNoteFooter>
    </JobEditNoteContainer>
  )
}

export default JobEditNote
